import { render, staticRenderFns } from "./PortalLoginModal.vue?vue&type=template&id=aafaf7b0"
import script from "./PortalLoginModal.vue?vue&type=script&lang=js"
export * from "./PortalLoginModal.vue?vue&type=script&lang=js"
import style0 from "./PortalLoginModal.vue?vue&type=style&index=0&id=aafaf7b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports